var _excluded = ["defaultOpen", "open", "onOpenChange"],
  _excluded2 = ["children", "asChild"],
  _excluded3 = ["children", "forceMount", "container"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useImperativeHandle, forwardRef as reactForwardRef } from 'react';
import { CrossIcon } from '@grupoboticario/flora-react-icons';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { CloseButtonStyles, HeaderStyles, OverlayStyles, BodyStyles, FooterStyles, TriggerStyles } from './styles';
export var Dialog = /*#__PURE__*/reactForwardRef((_ref, ref) => {
  var {
      defaultOpen,
      open: openProp,
      onOpenChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen != null ? defaultOpen : false,
    onChange: onOpenChange
  });
  var openDialog = () => setOpen(true);
  var close = () => setOpen(false);
  var toggle = () => setOpen(prev => !prev);
  useImperativeHandle(ref, () => ({
    open: openDialog,
    close,
    toggle,
    isOpen: open
  }));
  return /*#__PURE__*/React.createElement(DialogPrimitive.Root, _extends({
    open: open,
    onOpenChange: setOpen,
    modal: true
  }, props));
});
export var DialogTitle = DialogPrimitive.Title;
export var DialogDescription = DialogPrimitive.Description;
export var DialogTrigger = styled(DialogPrimitive.Trigger, TriggerStyles);
export var DialogFooter = styled('footer', FooterStyles);
export var DialogHeader = styled('header', HeaderStyles);
export var DialogBody = styled('main', BodyStyles);
var StyledDialogOverlay = styled('div', OverlayStyles);
var StyledDialogClose = styled(DialogPrimitive.Close, CloseButtonStyles);
/**
 * ### **Importante:**
 *
 * Este componente quando usado **SEM** a prop `asChild`, deve ser o primeiro elemento dentro do `DialogContent`.
 * Isso garante a correta leitura do leitor de tela e a funcionalidade de fechamento da caixa de diálogo.
 */
export var DialogClose = forwardRef((_ref2, ref) => {
  var {
      children,
      asChild = false
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  if (asChild) return /*#__PURE__*/React.createElement(DialogPrimitive.Close, _extends({
    "aria-label": "Fechar"
  }, props, {
    asChild: true
  }), children);
  return /*#__PURE__*/React.createElement(StyledDialogClose, _extends({
    "aria-label": "Fechar"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(CrossIcon, {
    color: "$linkDefault"
  }));
});
export var DialogContent = forwardRef((_ref3, ref) => {
  var {
      children,
      forceMount,
      container
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(DialogPrimitive.Portal, {
    forceMount: forceMount,
    container: container
  }, /*#__PURE__*/React.createElement(StyledDialogOverlay, {
    "data-flora": "overlay"
  }), /*#__PURE__*/React.createElement(DialogPrimitive.Content, _extends({
    "data-flora": "dialog-content"
  }, props, {
    ref: ref
  }), children));
});
//# sourceMappingURL=Dialog.js.map